import ModalExport from "./CustomModalExportTest";
import ModalResult from "./CustomModalResult";
import ModalPartnersCourse from "./CustomModalsPartnersCourse";
import ModalImportDiscounts from "./CustomModalImportDiscount";
import ModalOTSAssign from "./CustomModalOTSAssign";
import CustomModalChangeIncidences from "./CustomModalChangeIncidences";
import ModalSections from "./CustomModalSections";
import Create from "../Create";
import ModalChangeInsuranceGroup from "./CustomModalChangeInsuranceGroup";
import ModalImportEfpaMagazine from "./CustomModalImportEfpaMagazine";
import CustomModalCreateMassiveEmail from "./CustomModalCreateMassiveEmail";
import ModalImportCourseAssistants from "./CustomModalImportCourseAssistants";
import ModalImportPollQuestions from "./CustomModalImportPollQuestions";
import ModalImportQuestionnairesQuestions from "./CustomModalImportQuestionnairesQuestions";
import CustomModalSARChangeHoursAndRecertification from "./CustomModalSARChangeHoursAndRecertification";
import CustomModalDoubleAuthFactor from "./CustomModalDoubleAuthFactor";
import CustomModalImportWorkshopCourseAttendant from "./CustomModalImportWorkshopCourseAttendant";
import CustomModalImportWorkshopCourseAttendantHasAttended from "./CustomModalImportWorkshopCourseAttendantHasAttended";
import CustomModalGenerateMicroCredentialsExcel from "./CustomModalGenerateMicroCredentialsExcel";
import CustomModalRubactecSincro from "./CustomModalRubactecSincro";
import ModalImportEntityDropouts from "./CustomModalImportEntityDropouts";

const CustomModals = {
  ModalExport,
  ModalResult,
  ModalChangeInsuranceGroup,
  ModalImportEfpaMagazine,
  ModalPartnersCourse,
  ModalImportDiscounts,
  ModalSections,
  "assign-ots-team": ModalOTSAssign,
  "change-indicences-status": CustomModalChangeIncidences,
  create: Create,
  CustomModalCreateMassiveEmail,
  ModalImportCourseAssistants,
  ModalImportPollQuestions,
  ModalImportQuestionnairesQuestions,
  CustomModalSARChangeHoursAndRecertification,
  CustomModalDoubleAuthFactor,
  CustomModalImportWorkshopCourseAttendant,
  CustomModalImportWorkshopCourseAttendantHasAttended,
  CustomModalGenerateMicroCredentialsExcel,
  CustomModalRubactecSincro,
  ModalImportEntityDropouts
};

export default CustomModals;

